export const PATTERN_CEP = '11111-111';
export const PATTERN_CPF = '111.111.111-11';
export const PATTERN_CNPJ = '11.111.111/1111-11';
export const PATTERN_OLD_PHONE = '(11) 1111-1111';
export const PATTERN_OLD_PHONE_WITH_COUNTRY_CODE = '+11 (11) 1111-1111';
export const PATTERN_NEW_PHONE = '(11) 11111-1111';
export const PATTERN_NEW_PHONE_WITH_COUNTRY_CODE = '+11 (11) 11111-1111';
export const NEW_PHONE_SIZE = 11;
export const OLD_PHONE_WITH_COUNTRY_CODE_SIZE = 12;
export const NEW_PHONE_WITH_COUNTRY_CODE_SIZE = 13;
export const MAX_SIZE_PHONE = 11;
export const MIN_PHONE_CHARS = 6;
